/* eslint-disable */
import React, { useState } from "react";
import { Container, Col, Row, Card, Spacer, Icon } from "@cleartrip/bento";
import { Dropdown, OutsideClickHandler } from "components/composite/";
import { ReactComponent as Flight } from "assets/icons/flyinflight.svg";
import { ReactComponent as Hotel } from "assets/icons/flyinhotel.svg";
import { ReactComponent as Local } from "assets/icons/flyinlocal.svg";
import { ReactComponent as Fph } from "assets/icons/fph.svg";
import { ReactComponent as Staycations } from "assets/icons/flyinstaycation.svg";
import { ReactComponent as Reward } from "assets/icons/reward.svg";
import FlyinLogo from "assets/logos/flyinLogo.png";
import { align, getArabicFontStyle } from "helper/flyin";
import classNames from "classnames";

function FlyinHeader({ lng = "en" }) {
  const isRTL = align() === "rtl";
  const [active, setActive] = useState(false);

  const dropdownClickHandler = () => {
    setActive(!active);
  };

  const getLanguage = () => {
    if (align() === "rtl") {
      return "English";
    } else {
      return "عربي";
    }
  };

  const languageChangeHandler = (lng) => {
    const hostName = window.location.hostname;
    if(lng === 'en') {
      window.open("?lng=en","_self");
    } else {
      if(hostName === "www.flyin.com" || hostName === "qa2.flyin.com") {
        window.open("/travelsafe", "_self");
      } else {
        window.open("/travelsafe/flyin", "_self");
      }
    }
  }

  return (
    <header style={{ direction: align() }} className="bb bc-neutral-100">
      <Container>
        <Row className="flex-between">
          <Col className="flex flex-between d-none--xs">
            <Card className="h-11 pt-4 pb-3 flex-middle flex">
              <a href="/" className="flex">
                <img src={FlyinLogo} width={55} height={23} />
              </a>
            </Card>
            <Card className="flex-middle flex">
              <>
                <div className={classNames("flex flex-middle")}>
                  <a
                    target="_blank"
                    className="flex"
                    href={`https://www.flyin.com/aboutUs.${lng}.html#awards`}
                  >
                    <Reward />
                  </a>
                  <Spacer className="pl-6" />
                  <Icon
                    icon="call"
                    height="16px"
                    width="16px"
                    fill="#7799BE"
                    className={classNames({ flip: isRTL })}
                  />
                  <a
                    href="https://wa.me/+966112246333"
                    target="_blank"
                    style={{ direction: "ltr" }}
                    className={classNames("fs-2 td-none c-neutral-900 lh-solid", {
                      "ml-2": !isRTL,
                      "mr-2": isRTL,
                    })}
                  >
                    {"+966112246333"}
                  </a>
                  <div
                    className={classNames(
                      "p-relative",
                      isRTL ? "mr-4" : "ml-4"
                    )}
                  >
                    <OutsideClickHandler
                      className="p-relative"
                      onOutsideClick={() => setActive(false)}
                      style={getArabicFontStyle()}
                    >
                      <Dropdown.Select
                        border={false}
                        arrow={false}
                        label={<span className="fs-2" style={getArabicFontStyle()}>{getLanguage()}</span>}
                        className="bn p-2 hover:bg-neutral-0 br-4 lh-title fs-2"
                        width={38}
                        onClick={dropdownClickHandler}
                      ></Dropdown.Select>
                      {active && (
                        <Dropdown
                          className={classNames("", isRTL ? "l-0" : "r-0")}
                          overlayClassName="z-30"
                        >
                          <Dropdown.Item
                            className="hover:bg-secondary-500 c-pointer hover:c-white fs-2"
                            onClick={() => languageChangeHandler("ar")}
                          >
                            <span className="fs-2">عربي</span>
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="hover:bg-secondary-500 c-pointer hover:c-white fs-2"
                            onClick={() => languageChangeHandler("en")}
                          >
                            <span className="fs-2">English</span>
                          </Dropdown.Item>
                        </Dropdown>
                      )}
                    </OutsideClickHandler>
                  </div>
                </div>
              </>
            </Card>
          </Col>
          <Col className="d-none d-block--xs">
            <Card className="flex flex-center flex-middle h-11">
              <a href="/" className="flex">
                <img src={FlyinLogo} width={55} height={23} />
              </a>
            </Card>
          </Col>
        </Row>
      </Container>
    </header>
  );
}

export default FlyinHeader;
